import { render } from "./Spinner.vue?vue&type=template&id=9781611c&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=9781611c&scoped=true&lang=css"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9781611c"]])

export default __exports__